import { ITableHeader } from '@base/@types/components/Layout/TableGrid'
import { IParamsToSend } from '@base/@types/providers/Kpi/LogisticProvider'

export const parseRupturaKpiExportData = (
  headers: ITableHeader[],
  paramsToSend: IParamsToSend
) => {
  const headerFormatted = {
    configuracaoGrid: {
      periodo: headers[0].columns[0]?.show,

      centroCodigo: headers[1].columns[0]?.show,
      centroNome: headers[1].columns[1]?.show,

      gerenteCategoria: headers[2].columns[0]?.show,
      gerenteProduto: headers[2].columns[1]?.show,

      mundoCodigo: true,
      mundoNome: true,

      categoriaCompactaCodigo: headers[4].columns[0]?.show,
      categoriaCompactaNome: headers[4].columns[1]?.show,

      categoriaCodigo: headers[5].columns[0]?.show,
      categoriaNome: headers[5].columns[1]?.show,

      status: headers[6].columns[0]?.show,

      curvaABC: headers[7].columns[0]?.show,

      empresaCodigo: headers[8].columns[0]?.show,
      empresaNome: headers[8].columns[1]?.show,

      fornecedorCodigo: headers[9].columns[0]?.show,
      fornecedorNome: true,

      rupturaPercentualODias: true,
      rupturaPercentual1ODias: true
    }
  }

  return {
    ...paramsToSend,
    ...headerFormatted
  }
}
